import { useQuery, useQueryClient } from '@tanstack/react-query';
import { notificationService } from '@leoclinic/services';
import type { Notification } from '@leoclinic/types';

const NOTIFICATIONS_KEY = ['notifications'] as const;

export function useNotifications(profileId: string | null) {
  return useQuery<Notification[]>({
    queryKey: [...NOTIFICATIONS_KEY, profileId],
    queryFn: () => notificationService.listForProfile(profileId!),
    enabled: !!profileId,
    refetchInterval: 15 * 1000,
  });
}

export function useUnreadCount(profileId: string | null) {
  return useQuery<number>({
    queryKey: [...NOTIFICATIONS_KEY, 'unread', profileId],
    queryFn: () => notificationService.unreadCount(profileId!),
    enabled: !!profileId,
    refetchInterval: 15 * 1000,
  });
}

export function useNotificationMutations(profileId: string | null) {
  const queryClient = useQueryClient();
  const invalidate = () => queryClient.invalidateQueries({ queryKey: NOTIFICATIONS_KEY });

  return {
    markRead: async (id: string) => {
      await notificationService.markRead(id);
      invalidate();
    },
    markAllRead: async () => {
      if (profileId) await notificationService.markAllRead(profileId);
      invalidate();
    },
  };
}

export { NOTIFICATIONS_KEY };
